import React from "react";
import MobileRecording from "../recording/mobileRecording";
import MobileCancelButton from "../button/mobileCancelButton";
import MobileAddButton from "../button/mobileAddButton";
import MobileEditButton from "../button/mobileEditButton";
import MobileDeleteButton from "../button/mobileDeleteButton";
import MobileSaveButton from "../button/mobileSaveButton";
import MobileUpdateButton from "../button/mobileUpdateButton";
import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";

class AMobileListForm extends MobileRecording {
    LIST_MODE = 1;
    SHOW_MODE = 2;
    ADD_MODE = 3;
    EDIT_MODE = 4;

    availableModes = {
        list: false,
        add: false,
        show: false,
        edit: false,
        delete: false,
        deleteAll: false
    };

    state = {
        dataList: [],
        data: {},
        mode: this.LIST_MODE
    };

    recordList = [];
    tableDefinition = [];

    componentDidMount = () => {
        this.loadAllData();
    };

    getMobileDataForm = () => {
        return <React.Fragment/>;
    };
    loadAllData = async () => {
        let dataList = [];
        this.setState({dataList});
    };

    onRowClick = (state, rowInfo, column, instance) => {
        return {
            onClick: e => {
                this.setState({
                    mode: this.SHOW_MODE,
                    data: {...this.recordList[rowInfo.index]}
                });
            }
        };
    };

    setMode = mode => {
        this.setState({mode});
    };
    setListMode = () => {
        this.setState({mode: this.LIST_MODE});
    };
    setShowMode = () => {
        this.setState({mode: this.SHOW_MODE});
    };
    setEditMode = () => {
        this.setState({mode: this.EDIT_MODE});
    };

    clickButton = onHandler => {
        onHandler();
    };

    save = async data => {
        await this.loadAllData();
        this.setListMode();
    };

    update = async (id, data) => {
        await this.loadAllData();
        this.setListMode();
    };

    deleteAll = async () => {
    };

    delete = async id => {
        await this.loadAllData();
        this.setListMode();
    };

    renderBackToMenuButton = () => {
        return (
            <div className="btn-group mr-2" role="group">
                <MobileCancelButton
                    onClick={() => {
                        this.clickButton(this.onFieldCancel);
                    }}
                    // title={itButton.title}
                    title={{
                        text: "Hauptmenü",
                        style: {}
                    }}
                />
            </div>
        );
    };

    renderBackToListButton() {
        return (
            <div className="btn-group mr-2" role="group">
                <MobileCancelButton
                    onClick={() => {
                        this.setListMode();
                    }}
                    title={{
                        text: "Liste",
                        style: {}
                    }}
                />
            </div>
        );
    }

    renderCancelAddOrEditButton() {
        return (
            <div className="btn-group mr-2" role="group">
                <MobileCancelButton
                    onClick={() => {
                        this.setListMode();
                    }}
                    title={{
                        text: "Abbrechen",
                        style: {}
                    }}
                />
            </div>
        );
    }

    renderAddButton() {
        return (
            <div className="btn-group mr-2" role="group">
                <MobileAddButton
                    onClick={() => {
                        this.setAddMode();
                    }}
                    title={{
                        text: "Hinzufügen",
                        style: {}
                    }}
                />
            </div>
        );
    }

    renderEditButton() {
        return (
            <div className="btn-group mr-2" role="group">
                <MobileEditButton
                    onClick={() => {
                        this.setEditMode();
                    }}
                    title={{
                        text: "Bearbeiten",
                        style: {}
                    }}
                />
            </div>
        );
    }

    renderSaveButton(data) {
        return (
            <div className="btn-group mr-2" role="group">
                <MobileSaveButton
                    onClick={() => {
                        this.save(data);
                    }}
                    title={{
                        text: "speichern",
                        style: {}
                    }}
                />
            </div>
        );
    }

    renderUpdateButton(id, data) {
        return (
            <div className="btn-group mr-2" role="group">
                <MobileUpdateButton
                    onClick={() => {
                        this.update(id, data);
                    }}
                    title={{
                        text: "speichern",
                        style: {}
                    }}
                />
            </div>
        );
    }

    renderDeleteButton(id) {
        return (
            <div className="btn-group mr-2" role="group">
                <MobileDeleteButton
                    onClick={() => {
                        this.delete(id);
                    }}
                    title={{
                        text: "löschen",
                        style: {}
                    }}
                />
            </div>
        );
    }

    renderDeleteAllButton = () => {
        return (
            <div className="btn-group mr-2" role="group">
                <MobileDeleteButton
                    onClick={() => {
                        this.deleteAll();
                    }}
                    // title={itButton.title}
                    title={{
                        text: "alle löschen",
                        style: {}
                    }}
                />
            </div>
        );
    };

    render = () => {
        const {
            tableDefinition,
            getMobileDataForm,
            LIST_MODE,
            SHOW_MODE,
            ADD_MODE,
            EDIT_MODE
        } = this;
        const {data, dataList, mode} = this.state;
        const {database, currentFlowChart} = this.props;
        let columns = [];

        switch (mode) {
            case LIST_MODE:
                const ReactTableFixedColumns = withFixedColumns(ReactTable);

                columns.push({
                    Header: (
                        <React.Fragment>
                            <h2>
                                {currentFlowChart &&
                                currentFlowChart.title &&
                                currentFlowChart.title.text}
                            </h2>
                            <div className="btn-toolbar" role="toolbar">
                                {this.renderBackToMenuButton()}
                                {this.availableModes.deleteAll && this.renderDeleteAllButton()}
                            </div>
                        </React.Fragment>
                    ),
                    columns: []
                });

                for (let definition of tableDefinition) {
                    let definitionColumn = {};
                    if (definition.header) definitionColumn["Header"] = definition.header;
                    if (definition.field) definitionColumn["accessor"] = definition.field;
                    if (definition.width) definitionColumn["width"] = definition.width;
                    columns[0].columns.push(definitionColumn);
                }

                return (
                    <React.Fragment>
                        <ReactTableFixedColumns
                            columns={columns}
                            data={dataList}
                            defaultPageSize={dataList.length}
                            showPagination={false}
                            getTrProps={this.onRowClick}
                            //style={{ height: window.innerHeight }}
                        />
                    </React.Fragment>
                );

            case SHOW_MODE:
            case ADD_MODE:
            case EDIT_MODE:
                return React.cloneElement(getMobileDataForm(), {
                    database: database,
                    id: data.id,
                    listFormInstance: this
                });

            default:
                return <React.Fragment/>;
        }
    }
}

export default AMobileListForm;
